import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

/**
 * Hook to filter the response from the external API
 * @param {string} response
 * @returns {JSX.Element} Filtered response
 */
export const filterSuggestResponse = (response) => {
	return response?.split('\\n').map((line) => {
		if (line.includes(';')) {
			const rowData = line.split(';')
			let prestador = ''
			let distancia = ''
			let valorData = ''
			let symbol = ''
			let rapidez = ''
			let className = ''
			let percentagem = ''
			let number = -1
			rowData.map((data, index) => {
				switch (index) {
					case 0:
						prestador += data.replace(/['"()]/g, '').trim()
						break
					case 1:
						valorData = data
							? `${Number(data).toFixed(2)} € |`
							: '- € |'
						break
					case 2:
						distancia += data ? `${data} km | ` : '- km | '
						break
					case 3:
						rapidez += data ? `${data} d ` : '- d '
						break
					case 4:
						if (data) {
							const percentagem = Number(data)
							className =
								percentagem <= -10
									? '#8B0000'
									: percentagem > -10 && percentagem <= 0
									? '#8B0000'
									: percentagem > 0 && percentagem <= 10
									? '#d3b610'
									: percentagem > 10 && percentagem <= 30
									? '#23a823'
									: '#23a823'

							number =
								percentagem <= -10
									? 3
									: percentagem > -10 && percentagem <= 0
									? 2
									: percentagem > 0 && percentagem <= 10
									? 4
									: percentagem > 10 && percentagem <= 30
									? 0
									: 1
							symbol = getSymbol(number, className)
						} else {
							className = 'currentColor'
						}
						break
					default:
						break
				}
				return null
			})
			return (
				<VStack>
					{/* style={{ margin: '0px'}} */}
					<p>{prestador}</p>
					<small
						style={{
							margin: '0px',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{symbol}
						<span style={{ color: 'inherit' }}>
							{valorData} {distancia} {rapidez} {percentagem}
						</span>
					</small>
				</VStack>
			)
		} else {
			return null
		}
	})
}

const getSymbol = (value, className) => {
	switch (value) {
		case 0:
			return (
				<>
					<Icon
						name='fast-upward-one'
						style={{
							fill: className,
							marginRight: '5px',
						}}
						width='14px'
						height='14px'
					/>
				</>
			)
		case 1:
			return (
				<>
					<Icon
						name='fast-upward-two'
						style={{
							fill: className,
							marginRight: '5px',
						}}
						width='14px'
						height='14px'
					/>
				</>
			)

		case 2:
			return (
				<>
					<Icon
						name='fast-downward-one'
						style={{
							fill: className,
							marginRight: '5px',
						}}
						width='14px'
						height='14px'
					/>
				</>
			)
		case 3:
			return (
				<>
					<Icon
						name='fast-downward-two'
						style={{
							fill: className,
							marginRight: '5px',
						}}
						width='14px'
						height='14px'
					/>
				</>
			)
		case 4:
			return (
				<>
					<Icon
						name='equals'
						style={{
							fill: className,
							marginRight: '5px',
						}}
						width='16px'
						height='16px'
					/>
				</>
			)
		default:
			return null
	}
}
